import comp from "./AlertWithCheckbox";
export default comp;
